// extracted by mini-css-extract-plugin
export default {"primaryColor":"var(--primaryColor)"};